var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:{
    'level-item': true,
    button: true,
    'is-toggle': true,
    'is-on': _vm.isBigThumbnails
  },attrs:{"title":_vm.$t(_vm.isBigThumbnails ? 'tasks.small_thumbnails' : 'tasks.big_thumbnails')},on:{"click":_vm.toggleBigThumbnails}},[_c('grid-icon',{staticClass:"icon is-small"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }